if (!window.broadcastTraditionalBuyNowInitialized) {
  window.broadcastTraditionalBuyNowInitialized = true;

  document.addEventListener('click', async function(event) {
    const buyNowButton = event.target.closest('[data-buy-now]');

    if (!buyNowButton) return;

    event.preventDefault();

    const formId = buyNowButton.dataset.productFormId;
    const form = document.getElementById(formId);

    if (!form || buyNowButton.disabled) return;

    const variantInput = form.querySelector('.product-variant-id');

    if (!variantInput || variantInput.disabled || !variantInput.value) return;

    buyNowButton.disabled = true;
    buyNowButton.classList.add('is-loading');

    try {
      const formData = new FormData(form);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Unable to add product');
      }

      window.location.href = '/checkout';

    } catch (error) {
      console.error('Buy now error:', error);

      buyNowButton.disabled = false;
      buyNowButton.classList.remove('is-loading');
    }
  });
}